export default __webpack_public_path__ + "static/media/khaf-smart-sec1.d4dd62e2.jpg";